angular.module('SodTemplates', []);
(function () {
    'use strict';

    angular
        .module('SodTemplates')
        .run(runFunc);

    function runFunc($http, $templateCache, $q, $rootScope, $location, lodash) {
        $rootScope.templateLoader = $q.defer();

        var lang = angular.element('html').attr('lang');

        var types = angular.element('body').attr('data-app-type');
        if (lodash.isEmpty(types)) {
            types = '';
        }
        types = types.split('|');


        // $http.get('/api/admin/shared/templates-type').then(function (res) {
        //     var types = res.data.types;
        var promises = [];
        angular.forEach(types, function (val) {
            var templateUrl = '/api/admin/shared/templates/' + val;
            if (!!lang) {
                templateUrl += '?locale=' + lang;
            }
            var promise = $http.get(templateUrl);
            promises.push(promise);
            promise.then(function (res) {
                angular.forEach(res.data, function(_tpl, key) {
                    $templateCache.put(key, _tpl);
                });
            });
        });
        $q.all(promises).then(function () {
            $rootScope.templateLoader.resolve();
        });
        // }, function () {
        //     // redirect to 404
        //     $location.path('/500');
        // });
    }
})();
